module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/why-pict-060a02c8a989f556277bc91a652b5bf0.jpg";